import {App} from '@capacitor/app'
import {PluginListenerHandle} from '@capacitor/core'
import {AppUpdate, AppUpdateAvailability} from '@capawesome/capacitor-app-update'
import {useEffect, useRef, useState} from 'react'

import {isNativeMobileApp} from '../utils/platform'

const useGetAppUpdateInfo = () => {
  const [isAppUpdateAvailable, setIsAppUpdateAvailable] = useState(false)
  const [isImmediateUpdateAllowed, setIsImmediateUpdateAllowed] = useState(false)
  const listenerRef = useRef<PluginListenerHandle>()
  const checkForAppUpdateAvailability = async () => {
    const {
      immediateUpdateAllowed, updateAvailability,
    } = await AppUpdate.getAppUpdateInfo()
    setIsAppUpdateAvailable(
      updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE
    )
    setIsImmediateUpdateAllowed(immediateUpdateAllowed ?? false)
  }
  useEffect(() => {
    if (!isNativeMobileApp) return
    checkForAppUpdateAvailability()
    App.addListener('appStateChange', ({isActive}) => {
      isActive && checkForAppUpdateAvailability()
    }).then(listener => {
      listenerRef.current = listener
    })
    return () => {
      listenerRef.current?.remove()
    }
  })
  return {isAppUpdateAvailable, isImmediateUpdateAllowed}
}

export default useGetAppUpdateInfo
